export default "__VITE_ASSET__COzdjnUV__"